<style>
    ol, ul{
        margin-left: 1.25rem !important;
    }
    ol {
        list-style-type: decimal !important;
    }
    ul {
        list-style-type: disc !important;
    }


    .program-apply-modal .ant-modal-close{
        z-index: 9999 !important;
        position: fixed !important;
        top: 17px !important;
        right: 32px !important;
        color: white !important;
    }

    
    @media (max-width: 768px) {
        .program-apply-modal .ant-modal-close{
            top: 17px !important;
            right: 17px !important;
        }
        
        ul::-webkit-scrollbar {
            height: 11.4px;

        }
        
        ul::-webkit-scrollbar-track {
            background: white;
        }
    
        ul::-webkit-scrollbar-thumb {
            background-color: #969696;
            border-radius: 10px;
            border: 2px solid white;
        }
        
    }

</style>

<template>
    <layout-general-container :noSideSpacer="false" spaceToolbar>
        <div v-if="program" class="w-full grid bg-white grid-cols-12 gap-8 xl:gap-14 rounded-xl">
            <div class="flex flex-col col-span-12 lg:col-span-8 gap-8">
                <div class="flex flex-col md:flex-row justify-between md:items-end gap-8 md:gap-0 w-full">
                    <img :src="program.photo" class="inline md:hidden h-24 w-24 object-cover rounded-full" alt="">
                    <div class="flex flex-row gap-8 items-center">
                        <img :src="program.photo" class="hidden md:inline h-24 w-24 object-cover rounded-full" alt="">
                        <div class="flex flex-col gap-4">
                            <h1 class="text-3xl font-medium">{{ program.title }}</h1>
                            <h2 class="text-sm font-light leading-relaxed">{{  program.short_desc }}</h2>
                            <div class="flex flex-row flex-wrap font-sans gap-4 items-center">
                                <span class="flex w-fit text-[.7rem] bg-[#e6e4dc] px-3 py-1 items-center">{{
                                    program.type
                                }}</span>
                                <span class="flex w-fit text-[.7rem] bg-[#e6e4dc] px-3 py-1 items-center">{{ (program.batch).toUpperCase() }}</span>
                                <span class="text-[.7rem] px-3 py-1 flex items-center font-medium"
                                    :class="program.status === 'Upcoming' ? 'bg-[#40BD3C] text-[#e6e4dc]' : (program.status === 'Ended' ? 'bg-[#ef4444] text-[#e6e4dc]' : 'bg-[#0668e7] text-[#e6e4dc]')"
                                >
                                    <a-badge :color="program.status === 'Upcoming' ? '#fff' : '#fff'" />
                                    {{ program.status === 'Upcoming' && enrolled ? 'Awaiting' : program.status }}
                                </span>
                                <div class="flex flex-row gap-2 text-light items-center">
                                    <IconCalendarStats :stroke-width="1.5" :size="18" />
                                    <span class="text-xs">{{ moment(program.start_date).format('MMM DD, YYYY') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a-button type="primary" :class="'btn-apply-detail-'+program.slug" id="program-detail-apply" v-if="program?.status == 'Ongoing' ? program?.isOpen : program?.status != 'Ended'" @click="handleApply" :loading="isApplyLoading" :disabled="isApplyDisabled">{{ applyText }}</a-button>
                </div>
                <a-divider class="my-1"></a-divider>
                <div class="flex flex-col gap-2 text-[.9rem] font-light leading-loose" v-html="sanitizedDesc(program.desc)">
                </div>
                <div class="flex w-full flex-col gap-3" v-if="JSON.parse(program.benefit).length > 0 && JSON.parse(program.benefit)[0]?.value_benefit != null">
                    <span class="font-medium text-base">Benefit</span>
                    <div class="w-full grid grid-cols-2 xl:grid-cols-3 gap-3">
                        <div class="w-full bg-white p-5 gap-3 md:gap-5 md:items-center border-r flex flex-col md:flex-row"  v-for="(benefit, indexBenefit) in JSON.parse(program.benefit)" :key="indexBenefit">
                             <i :class="benefit.icon_benefit" class="text-primary min-w-min" :size="32"></i>
                            <span class="text-sm leading-relaxed">{{ benefit.value_benefit }}</span>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col w-full gap-4" v-if="JSON.parse(program.requirement).length > 0 && JSON.parse(program.requirement)[0]?.requirement_value != null">
                    <span class="font-medium text-base">Requirement</span>
                    <div class="flex flex-col gap-3">
                        <div class="flex flex-row gap-2" v-for="(requirement, indexRequirement) in JSON.parse(program.requirement)" :key="indexRequirement">
                            <IconRosetteDiscountCheck class="min-w-max text-primary" :size="18" />
                            <span class="text-[.9rem] font-light">{{ requirement.requirement_value }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-12 lg:col-span-4 gap-3">
                <span class="text-base font-medium">Other Programs</span>
                <card-program class="w-full" v-for="item in similarProgram" :enrolled="['Enrolled', 'Completed'].includes(item.isEnrolled)" :tag="'btn-apply-detail-other-'+item.slug" :statusEnrolled="item.isEnrolled" :discovery="true" :key="item.id" :name="item.title"
                :isOpen="item.isOpen"
                        :id="item.id" :slug="item.slug" :image="item.photo" :type="item.type" :description="item.short_desc"
                        :status="item.status" :date="moment(item.start_date).format('MMM DD, YYYY')" :batch="item.batch" />
            </div>
        </div>
        <a-modal width="100%" wrap-class-name="full-modal" @cancel="closeModalApply" v-model:open="modalApply" centered class="relative program-apply-modal">
            <template #title>
                <div class="fixed top-0 w-full mx-auto left-0 right-0 bg-banner-1 opacity-90 bg-primary z-50">
                    <div class="flex sm:hidden items-end justify-start absolute left-0 bottom-0 h-full w-8 z-10 pointer-events-none">
                        <div class="bg-white w-3 h-3 rounded-sm flex items-center justify-center">
                            <IconCaretLeftFilled class="text-[#969696]" :stroke-width="1.5" :size="12" />
                        </div>
                    </div>    
                    
                    <div class="flex sm:hidden items-end justify-end absolute right-0 bottom-0 h-full w-8 z-10 pointer-events-none">
                        <div class="bg-white w-3 h-3 rounded-sm flex items-center justify-center">
                            <IconCaretRightFilled class="text-[#969696]" :stroke-width="1.5" :size="12" />
                        </div>
                    </div>
                    
                    <ul class="mx-auto flex mt-12 list-none flex-row flex-nowrap items-center pb-4 w-full sm:w-fit max-w-full justify-start overflow-x-scroll sm:overflow-x-auto whitespace-nowrap text-white">
                        <li v-for="(step, indexStep) in steps" :key="indexStep" class="border-e-2 border-white last:border-0">
                            <a :href="'#tab-form-'+step.section_id"
                                :class="['block px-6 text-base lg:text-lg leading-6 whitespace-nowrap hover:text-accent mx-1',
                                    activeStepIndex === step.section_id ? 'text-accent font-bold' : 'font-medium'
                                ]"
                                @click.prevent="scrollToSection(step.section_id)"
                                v-if="step.parent_id == null || Object.values(sectionBranching).includes(step.section_id)"
                            >
                                {{ step.section_name }}
                            </a>
                        </li>
                    </ul>

                    <hr>
                </div>
            </template>

            <div v-if="applyForms.length">
                <div v-for="(forms) in applyForms" :key="forms.section_id">
                    <div v-if="forms.parent_id == null || Object.values(sectionBranching).includes(forms.section_id)"  class="first:mt-24 mt-8 md:mb-0 mb-4">
                        <div class="flex flex-col gap-2 scroll-mt-24 mb-0" :id="'tab-form-'+forms.section_id">
                            <span class="text-2xl tracking-wide text-light font-semibold">{{ forms.section_name }} </span>
                        </div>
        
                        <div class="grid grid-cols-12 gap-6 md:py-6">
                            <form-apply :forms="forms.questions" :errors="errors" :formField="formField" @updateStepIndex="activeStepIndex = $event" :step="forms.section_id" :sectionBranching="sectionBranching" />
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="border-t-2 w-full flex justify-end pt-4">
                    <a-button @click="submitApply(true)" type="primary" ghost size="large" :loading="isSaveLoading">Save</a-button>
                    <a-button @click="submitApply()" type="primary" size="large" :loading="isSubmitLoading">Submit</a-button>
                </div>
            </template>
        </a-modal>
    </layout-general-container>
</template>

<script setup>
    import axios from "@/plugins/axios";
    import { useBreakpoint } from '@/composables/useBreakpoints';
    import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
    import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
    import DummyProgram from '../../assets/Dummy/program.js';
    import useAuth from '@/composables/useAuth'
    import moment from "moment";
    import DOMPurify from 'dompurify';

    const { lgAndUp } = useBreakpoint();

    // Import only used icons
    import {
        IconCalendarStats,
        IconHeartHandshake,
        IconBuildingEstate,
        IconUsersGroup,
        IconPresentationAnalytics,
        IconChartInfographic,
        IconTopologyStar,
        IconRosetteDiscountCheck,
        IconCaretRightFilled,
        IconCaretLeftFilled,
    } from '@tabler/icons-vue';
    import { message } from "ant-design-vue";
    import dayjs from "dayjs";


    const program = ref(null);
    const similarProgram = ref([]);
    const modalApply = ref(false);
    const applyForms = ref([]);
    const applyText = ref('');
    const isSaveLoading = ref(false);
    const isSubmitLoading = ref(false);
    const isApplyLoading = ref(true);
    const isApplyDisabled = ref(false);
    const saveInterval = ref(null);

    const sectionBranching = ref({});
    const columnChildBranching = ref({});

    const steps = ref([
        'Information Detail',
        'Business Model',
        'Funding',
        'Submit Your Application'
    ]);

    const formField = ref({});
    const isFormDirty = ref(false);
    const isFromSave = ref(true);

    const errors = ref({});

    const currentStep = ref(1);
    const totalSteps = ref(4);

    const route = useRoute();

    const router = useRouter();
    const auth = useAuth();

    const accountCheck = ref(null);
    const activeStepIndex = ref(null);

    watch(() => sectionBranching.value, (newValue) => {
        if (newValue) {
            const mergeNewValue = Object.values(newValue).flat()
            const getSections = applyForms.value.filter(form => 
                !mergeNewValue.includes(form.section_id) && form.parent_id != null
            );
            
            (getSections).forEach((section) => {
                let childs = [];

                (section.questions).forEach((question) => {
                    childs.push(question.col_name);
                })

                columnChildBranching.value[section.section_id] = childs;
            });

        }            

    }, { deep: true });

    watch(() => route.params.ProgramID, async (newValue) => {
        await fetchProgram()
        await fetchSimilarProgram()
        await fetchApplyForms()

        if (route.query['apply-open'] == 'true') {
            setTimeout(() => {
                modalApply.value = true;
            }, 500);
        }
    });

    watch(() => modalApply.value, async (newValue) => {
        if (newValue) {
            saveInterval.value = await setInterval(function() {
                submitApply(true, true);
            }, 60000);
        }else{
            clearInterval(saveInterval.value);
        }
    });

    watch(() => applyText.value, (newValue) => {
        if (newValue == 'Coming Soon' || newValue == 'Submitted') {
            isApplyDisabled.value = true;
        }
    });

    watch(() => formField.value, (newValue) => {
        Object.keys(formField.value).forEach((data, indexData) => {
            if (newValue[data]) errors.value[data] = '';
        });

        if (newValue && !isFromSave.value) {
            isFormDirty.value = true;
        };
    }, { deep: true });

    onBeforeRouteLeave((to, from, next) => {
        if (isFormDirty.value && modalApply.value) {
            const answer = window.confirm('You may have unsaved changes. Do you want to continue?');
            if (!answer) {
                next(false);
                return;
            }
        }

        next();
    });

    watch(() => applyForms.value, (newValue) => {
        if (newValue) {
            setDefaultFormField()
            setTimeout(() => {
                isFromSave.value = false;
            }, 1000);
        }
    });

    const handleBeforeUnload = (event) => {
        if (isFormDirty.value && modalApply?.value) {
            event.preventDefault();
            event.returnValue = "";
        }
    };

    const closeModalApply = () => {
        modalApply.value = true;
        if (isFormDirty.value && modalApply.value) {
            const answer = window.confirm('You may have unsaved changes. Do you want to continue?');
            if (!answer) {
                return;
            }
        }
        
        modalApply.value = false;
    };

    const sanitizedDesc = (desc) => {
        return DOMPurify.sanitize(desc);
    }

    onMounted(async () => {
        await initMethod();

        window.addEventListener("beforeunload", handleBeforeUnload);

        if (route.query['apply-open'] == 'true') {
            setTimeout(() => {
                modalApply.value = true;

                const query = { ...route.query };
                delete query['apply-open'];

                router.replace({ query });
            }, 500);
            
        }
    });

    const initMethod = async () => {
        await accountCompleteProgress();
        await fetchProgram();
        await fetchSimilarProgram();
        await fetchApplyForms();
    }

    onBeforeUnmount(() => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
    });

    const fetchProgram = async () => {
        try {
            const response = await axios.get(`/program/${route.params.ProgramID}`);
            program.value = response?.data;
            
            if (route.params.ProgramID == program.value.id) {
                router.replace({ name: 'ProgramDetailScreen', params: { ProgramID: program?.value?.slug } });
            }

            if (['Enrolled', 'Completed'].includes(program.value.isEnrolled)) {
                window.location.href = `/Internal/Program/Detail/${route.params.ProgramID}`;
            }
        } catch (error) {
            if (error?.response?.status == 404 || error?.response?.status == 301) {
                window.location.href = '/missing-page';
            }

            console.error('Error fetching program:', error)
        }
    }

    const fetchSimilarProgram = async () => {
        try {
            const response = await axios.get(`/program/${route.params.ProgramID}/other-program`);
            similarProgram.value = response?.data;
        } catch (error) {
            console.error('Error fetching similar program:', error)
        }
    }

    const fetchApplyForms = async () => {
        const user = auth.get().user;

        if (user) {
            try {
                const response = await axios.get(`/program/apply_form/${program?.value?.id}`);
    
                if (response?.data.length === 0) {
                    return;
                }
                
                applyForms.value = response.data;
                steps.value = applyForms.value;
                totalSteps.value = (steps.value).length;
            } catch (error) {
                
                console.error('Error fetching apply forms:', error)
            }
        }
        
        applyText.value = setApplyTextValue(program?.value?.status, program?.value?.isEnrolled);
        isApplyLoading.value = false;
    }

    const groupBySectionForm = (data) => {
        return data.reduce((result, item) => {
            // Cek apakah `section_form` udah ada di hasil grouping
            if (!result[item.section_form]) {
                result[item.section_form] = [];
            }
            // Masukin item ke array section_form yang sesuai
            result[item.section_form].push(item);
            return result;
        }, {});
    };

    const handleApply = () => {
        if (!auth.get().authenticated) {
            sessionStorage.setItem('redirectAfterLogin', router.currentRoute.value.fullPath);

            if (program) {
                router.push({ name: "AuthenticationSignUpScreen" });
            }
            return;
        }

        if (accountCheck.value?.percentage < 100) {
            message.error('Please complete your verification account first.');
            router.push('/Internal/Core');
        }else{
            modalApply.value = true;
        }
    };

    const setDefaultFormField = async () => {
        let continueApply = false;
        let form = {};
        let errorObj = {};

        (applyForms.value).forEach((groupSections, key) => {
            (groupSections.questions).forEach(async (item, key)  => {
                let defaultValue = item?.saved_answer;
                let attachmentFile = null;

                if (item?.saved_answer) {
                    continueApply = true;
                }

                if (['select_dropdown', 'select_dropdown_api', 'select_dropdown_branching'].includes(item.type)) {
                    defaultValue = item?.saved_answer ?? '';
                }

                if (item.type === 'date') {
                    defaultValue = item?.saved_answer ? dayjs(item?.saved_answer, 'YYYY-MM-DD') : '';
                }

                if (item.type === 'checklist') {
                    defaultValue = typeof item?.saved_answer == 'string' ? JSON.parse(item?.saved_answer) : item?.saved_answer;
                }

                if (['file', 'image'].includes(item.type)) {
                    defaultValue = item?.saved_answer ? await getFile(item.saved_answer) : '';
                    attachmentFile = item?.attachment ? await getFile(item.attachment, true) : null;
                }

                if (['radiobutton_branching', 'select_dropdown_branching'].includes(item.type)) {
                    const childPage = item.form_option.find(value => value.option === defaultValue);
                    const sectionId = childPage ? childPage.form_section_id : null;

                    sectionBranching.value[item.id] = sectionId;
                }

                form[item.col_name] = defaultValue;
                errorObj[item.col_name] = '';

                item['attachmentFile'] = attachmentFile;
            })
        })
        
        let applyTextTemp = 'Continue To Apply';

        if (!continueApply) {
            applyTextTemp = setApplyTextValue(program?.value?.status, program?.value?.isEnrolled);
        }

        applyText.value = applyTextTemp

        isApplyLoading.value = false;
        
        formField.value = form;
        errors.value = errorObj;
    };

    const setApplyTextValue = (status, isEnrolled, isOpen = false) => {
        const text = ['Upcoming', 'Awaiting'].includes(status) ? 'Coming Soon'  : (isEnrolled == 'Submitted' ? 'Submitted' : 'Apply');

        return text;
    }

    const getFile = async (uri, isAttachment = false) => {
        let result = ''

        try {
            const response = await axios.get(uri, {
                responseType: 'blob',
            });

            result = response?.data

            if (isAttachment) {
                result = {
                    'file': URL.createObjectURL(result),
                    'type': response.headers.get('Content-Type')
                }
            }

            return result;
        } catch (error) {
            console.error('Error fetching file: ' ,error)
        }
        return result
    }

    const accountCompleteProgress = async () => {
        const user = auth?.get()?.user;

        if (user) {
            try {
                const response = await axios.get('check-account')
                accountCheck.value= response.data
            } catch (error) {
                console.error('Error fetching check account: ' ,error)
            }
        }
    }

    const nextStep = () => {
        if (currentStep.value < totalSteps.value) {
            currentStep.value++;
            return;
        }
        modalApply.value = false
    };
    
    const prevStep = () => {
        if (currentStep.value > 1) {
            currentStep.value--;
        }
    };

    const scrollToSection = (index) => {
        const target = document.getElementById(`tab-form-${index}`);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const handleBackendErrors = (backendErrors) => {
        Object.keys(backendErrors).forEach(field => {
            if (errors.value[field] !== undefined) {
                errors.value[field] = backendErrors[field][0]; // Display the first error for each field
            }
        });
    };


    const submitApply = async (isDraft = false, autoSaved = false) => {
        try {
            const formData = new FormData();

            const mergeColumnBranching = Object.values(columnChildBranching.value).flat()
            Object.keys(formField.value).forEach((key) => {
                if (mergeColumnBranching.includes(key)) {
                    formData.append(key, '');
                    return;
                }

                if (Array.isArray(formField.value[key])) {
                    formField.value[key].forEach((item, index) => {
                        formData.append(`${key}[${index}]`, item);
                    });

                    return;
                }
                
                if (dayjs(formField.value[key], "YYYY-MM-DD", true).isValid()) {
                    formData.append(key, dayjs(formField.value[key]).format("YYYY-MM-DD"));
                    
                    return;
                }

                if (typeof formField.value[key] === 'boolean') {
                    formData.append(key, formField.value[key] ? 1 : 0);

                    return;
                }

                formData.append(key, formField.value[key] ?? '');
            });

            if (isDraft) {
                isSaveLoading.value = true;
                let response = await axios.post(`/save_draft/${program?.value?.id}`, formData);
                
                if (!autoSaved) {
                    message.success(response?.data?.message);
                }

                resetValueIsForm();
            }else{
                isSubmitLoading.value = true;
                await axios.post(`/program/enroll/${program?.value?.id}`, formData);
                
                message.success('Success apply program');

                await initMethod();
                resetValueIsForm();
                closeModalApply();
            }

            resetValueIsForm();

        } catch (error) {
            if (error?.response && error?.response?.data && error?.response?.data?.errors) {
                handleBackendErrors(error?.response?.data?.errors);
            } 
            
            console.error(error?.response?.data?.message);
            message.error(error?.response?.data?.message ?? 'An error occurred while submitting the form. Please try again later.');
        } finally{
            isSaveLoading.value = false;
            isSubmitLoading.value = false;
        }


    };

    const resetValueIsForm = () => {
        isFormDirty.value = false;
        isFromSave.value = false;
    }
</script>
